import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  formatPageTitle,
  getDefaultOgImage,
  getDefaultRobots,
} from '../../config/seoConfig';

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalUrl,
  image,
  robots,
  keywords,
}) => {
  const pageTitle = formatPageTitle(title);
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const metaRobots = robots || getDefaultRobots();
  const ogImage = image || getDefaultOgImage();
  const ogUrl = canonicalUrl || undefined;

  return (
    <Helmet>
      <title>{pageTitle || DEFAULT_TITLE}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="robots" content={metaRobots} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
